export default __webpack_public_path__ + "static/media/texto_saltos_branco.1dce6e97.png";